import { combineReducers } from 'redux';
import newBooking from '../reducers/newBooking';
import environment from '../reducers/environment';
import entities from '../reducers/entities';

const rootReducer = combineReducers({
    newBooking,
    entities,
    environment,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./scripts/reducers/index.js